import { useForm, useWatch } from 'react-hook-form';
import { useSelector } from 'react-redux';

import { useEffect, useMemo, useRef } from 'react';
import { DEFAULT_FORM_STATE } from '../constants/defaultFormState';
import { selectDefaultFormState } from '../selectors';
import { IFormState, TElement } from '../types/calculator';
import { useCalculatorCustomEvents } from './useCalculatorCustomEvents';

export const useCalculatorForm = (formScheme: TElement[], formRef: HTMLFormElement | null) => {
  const preselectedFormValues = useSelector(selectDefaultFormState);

  const reactHookForm = useForm<IFormState>({
    mode: 'onChange',
  });

  const { formState, reset, control, getValues } = reactHookForm;
  const watchedFormValues = useWatch({ control }) as IFormState;
  // Явно читаем formState, чтобы RHF доставлял обновления в этот рендер (см. форму RHF 7+).
  const { isValid, errors, isDirty, dirtyFields, touchedFields, submitCount } = formState;

  // `reset` только по смене *содержимого* defaults (не по новой ссылке на тот же объект) — иначе поля ввода сбрасываются.
  const preselectedKey = useMemo(() => JSON.stringify(preselectedFormValues ?? null), [preselectedFormValues]);
  const preselectedRef = useRef(preselectedFormValues);
  preselectedRef.current = preselectedFormValues;
  // установка дефолтных значение при инициализации
  useEffect(() => {
    reset({
      ...DEFAULT_FORM_STATE,
      ...preselectedRef.current,
    });
  }, [preselectedKey, reset]);

  // TODO: данный хук добавляет дополнительные рендеры, нужно оптимизировать
  useCalculatorCustomEvents({
    getValues,
    watchedFormValues,
    isValid,
    errors,
    isDirty,
    dirtyFields,
    touchedFields,
    submitCount,
    eventTarget: formRef,
    formScheme,
  });

  return { reactHookForm };
};
